import React from 'react'
import * as Config from "../../lib/config";

const staticIntroduction = (props) => {
  const { heading, metaData = [] } = props;
  // const { heading, discription1, discription2, metaData = [] } = props;
  return (
    <>
    <div className='row static-intro'>
        <div className='commanSmallFontHeading col-12 text-left'>{heading}</div>
        <div className='col-12 col-md-9 text-left pr-0'>
          <ul>
            {metaData.length > 0 && metaData.map((item, index) => (
              <li key={`${index}-key`}>                
                <div className='py-2'>{item}</div>
              </li>
            ))}
            {/* {discription1 && <div className='py-2'>{discription1}</div>}
            {discription2 && <div className='py-2'>{discription2}</div>} */}
          </ul>
        </div>
        
        <div className='col-12 col-md-3 static-intro-store-col'>
            <div className='static-intro-store-badges'>
              <a target="_blank" rel="noreferrer" href={Config.LED_BANNER_APP_STORE_URL}>
                <img
                  src={Config.images.appstore}
                  alt="Download on the App Store"
                  className='img-fluid'
                />
              </a>
              <a target="_blank" rel="noreferrer" href={Config.LED_BANNER_PLAY_STORE_URL}>
                <img
                  src={Config.images.playstore}
                  alt="Get it on Google Play"
                  className='img-fluid'
                />
              </a>
            </div>
          </div>
    </div>
    </>
  )
}

export default staticIntroduction
